<div *ngIf="mostrarBarraNav" class="">
    <!-- Contenedor Header -->
     <header class="top-0 z-50 w-full shadow-md py-4 px-4 sm:px-10 bg-azul tracking-wide">
        <div class='flex flex-wrap items-center justify-between gap-5 w-full'>
            <!-- Logo LG -->
            <a href="" class="max-sm:hidden">
                <img width="50px" src="../../assets/img/logo.png" alt="logo">
            </a>
            <!-- Elementos Barra Nav -->
            <div #collapseMenu id="collapseMenu" class='max-lg:hidden lg:!block max-lg:before:fixed max-lg:before:bg-black max-lg:before:opacity-50 max-lg:before:inset-0 max-lg:before:z-50'>
                <button id="btnCerrar" (click)="mostrarNav()" class='lg:hidden fixed top-2 right-4 z-[100] rounded-full bg-white w-9 h-9 flex items-center justify-center border'>
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 fill-black" viewBox="0 0 320.591 320.591">
                        <path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" data-original="#000000"></path>
                        <path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" data-original="#000000"></path>
                    </svg>
                </button>

                <ul class='lg:flex gap-x-5 max-lg:space-y-3 max-lg:fixed max-lg:bg-azul max-lg:w-1/2 max-lg:min-w-[300px] max-lg:top-0 max-lg:left-0 max-lg:p-6 max-lg:h-full max-lg:shadow-md max-lg:overflow-auto z-50'>
                    <li class='mb-6 hidden max-lg:block'>
                        <a href=""><img src="../../assets/img/logo.png" alt="logo" class='w-36' /></a>
                    </li>
                    <li class='mb-6 hidden max-lg:block'>
                        <hr class="text-white">
                    </li>
                    <li>
                        <a *ngIf="!usuario" routerLink="inicioSesion" class="btnInicioSesion">
                            <mat-icon fontIcon="person_outline"></mat-icon>
                            <span>{{'iniciar-sesion' | translate}}</span>
                        </a>
                        <div *ngIf="usuario" class="text-white font-medium w-full lg:w-auto lg:relative" appToggleMenu (clickOutside)="clickFuera()">
                            <div (click)="menuOpciones()" class="btnInicioSesion">
                                <mat-icon fontIcon="person_outline"></mat-icon>
                                <span>{{usuario.usuario.nombre}}</span>
                            </div>
                            <div *ngIf="menuDesplegado" class=" mt-2 bg-white rounded-lg shadow-inner p-4 space-y-2 text-azul w-full lg:absolute lg:top-full lg:left-0 lg:mt-2 lg:w-48 lg:shadow-lg lg:z-50">
                                <!-- Perfil Aficionado -->
                                <div class="hover:bg-gray-100 px-4 py-2 rounded cursor-pointer flex items-center gap-2" *ngIf="usuario.usuario.tipo === 'aficionado'" routerLink="perfilUsuario">
                                    <mat-icon fontIcon="person_outline"></mat-icon>
                                    <span>{{'perfil' | translate}}</span>
                                </div> 
                                <!-- Perfil Cuerpo Tecnico -->
                                <div class="hover:bg-gray-100 px-4 py-2 rounded cursor-pointer flex items-center gap-2" *ngIf="usuario.usuario.tipo === 'cuerpotecnico'" [routerLink]="'cuerpoTecnico/'+cuerpoTecnico.ID">
                                    <mat-icon fontIcon="person_outline"></mat-icon>
                                    <span>{{'perfil' | translate}}</span>
                                </div>
                                <!-- Perfil Jugador -->
                                <div class="hover:bg-gray-100 px-4 py-2 rounded cursor-pointer flex items-center gap-2" *ngIf="usuario.usuario.tipo === 'jugador'" [routerLink]="'jugador/'+jugador.id">
                                    <mat-icon fontIcon="person_outline"></mat-icon>
                                    <span>{{'perfil' | translate}}</span>
                                </div>                                 
                                <!-- Area Pedidos -->
                                <div class="hover:bg-gray-100 px-4 py-2 rounded cursor-pointer flex items-center gap-2" *ngIf="usuario.usuario.tipo === 'aficionado'" routerLink="areaPedidos">
                                    <mat-icon fontIcon="inventory_2"></mat-icon>
                                    <span>{{'area-pedidos' | translate}}</span>
                                </div>
                                <!-- Area Entradas Partidos -->
                                <div class="hover:bg-gray-100 px-4 py-2 rounded cursor-pointer flex items-center gap-2" *ngIf="usuario.usuario.tipo === 'aficionado'" routerLink="areaEntradas">
                                    <mat-icon fontIcon="confirmation_number"></mat-icon>
                                    <span>{{'area-entradas' | translate}}</span>
                                </div>
                                <!-- Cerrar Sesion -->
                                <div class="hover:bg-red-300 px-4 py-2 rounded cursor-pointer flex items-center gap-2 text-red-600" (click)="cerrarSesion()">
                                    <mat-icon fontIcon="cancel"></mat-icon>
                                    <span>{{'cerrar-sesion' | translate}}</span>
                                </div>
                            </div>
                        </div>
                    </li>
                    <!-- Cambiar Idioma -->
                    <li>
                        <button (click)="cambiarIdioma()" class="btnInicioSesion flex items-center space-x-2">
                            <mat-icon fontIcon="language"></mat-icon>{{'cambiar-idioma' | translate}}
                        </button>
                    </li>
                    <!-- Tienda -->
                    <li *ngIf="aficionado">
                        <a *ngIf="usuario" routerLink="tienda" class="btnInicioSesion">
                            <mat-icon fontIcon="shopping_cart"></mat-icon>
                            <span>{{'tienda' | translate}}</span>
                        </a>
                    </li>
                    <!-- Partidos Aficionado -->
                    <li *ngIf="aficionado">
                        <a *ngIf="usuario" routerLink="partidos" class="btnInicioSesion">
                            <mat-icon fontIcon="stadium"></mat-icon>
                            <span>{{'partidos' | translate}}</span>
                        </a>
                    </li>
                    <!-- Calendario -->
                    <li>
                        <a *ngIf="usuario && (cuerpoTecnico || jugador)" routerLink="calendario" class="btnInicioSesion">
                            <mat-icon fontIcon="calendar_month"></mat-icon>
                            <span>{{'calendario' | translate}}</span>
                        </a>
                    </li>
                    <!-- Partidos Equipo -->
                    <li *ngIf="(cuerpoTecnico || jugador)">
                        <a *ngIf="usuario  && cuerpoTecnico" [routerLink]="'partidos/equipo/'+cuerpoTecnico.equipo_id" class="btnInicioSesion">
                            <mat-icon fontIcon="sports_soccer"></mat-icon>
                            <span>{{'mis-partidos' | translate}}</span>
                        </a>
                        <a *ngIf="usuario  && jugador" [routerLink]="'partidos/equipo/'+jugador.equipo_id" class="btnInicioSesion">
                            <mat-icon fontIcon="sports_soccer"></mat-icon>
                            <span>{{'mis-partidos' | translate}}</span>
                        </a>
                    </li>
                    <!-- Plantilla Equipo -->
                    <li *ngIf="(cuerpoTecnico || jugador)">
                        <a *ngIf="usuario && cuerpoTecnico" [routerLink]="'miEquipo/'+cuerpoTecnico.equipo_id" class="btnInicioSesion">
                            <mat-icon fontIcon="groups"></mat-icon>
                            <span>{{'equipo' | translate}}</span>
                        </a>
                        <a *ngIf="usuario  && jugador" [routerLink]="'miEquipo/'+jugador.equipo_id" class="btnInicioSesion">
                            <mat-icon fontIcon="groups"></mat-icon>
                            <span>{{'equipo' | translate}}</span>
                        </a>
                    </li>
                    <!-- Area Entrenamientos -->
                    <li *ngIf="(cuerpoTecnico || jugador)">
                        <a *ngIf="usuario && (cuerpoTecnico || jugador)" routerLink="areaentrenamientos" class="btnInicioSesion">
                            <mat-icon fontIcon="fitness_center"></mat-icon>
                            <span>{{'area-entrenamientos' | translate}}</span>
                        </a>
                    </li>
                    <!-- Area Dietas IA -->
                    <li *ngIf="jugador">
                        <a *ngIf="usuario && jugador" routerLink="iadietas" class="btnInicioSesion">
                            <mat-icon fontIcon="restaurant"></mat-icon>
                            <span>{{'dietas' | translate}}</span>
                        </a>
                    </li>
                    <!-- Area Ojeador -->
                    <li *ngIf="cuerpoTecnico">
                        <a *ngIf="usuario && cuerpoTecnico" routerLink="areaojeador" class="btnInicioSesion">
                            <mat-icon fontIcon="search"></mat-icon>
                            <span>{{'area-ojeador' | translate}}</span>
                        </a>
                    </li>
                </ul>
            </div>
            <!-- Boton abrir menu sm -->
            <div class='flex items-center space-x-4'>
                <button id="btnAbrir" class='lg:hidden' (click)="mostrarNav()">
                    <svg class="w-7 h-7" fill="#000" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd"></path>
                    </svg>
                </button>
                <!-- Carro de compra -->
                <div *ngIf="productosCarrito.length > 0">
                    <a routerLink="carrito" class="relative">
                      <button class="btnInicioSesion">
                        <mat-icon fontIcon="shopping_cart"></mat-icon>
                      </button>
                      <span *ngIf="cantidadProductos > 0" class="absolute top-0 right-0 bg-red-600 text-white text-xs rounded-full px-2">{{ cantidadProductos }}</span>
                    </a>
                </div>
            </div>
        </div>
    </header>
</div>
